import { FormControl } from '@@/form-components/FormControl';
import { Switch } from '@@/form-components/SwitchField/Switch';
import { FormSection } from '@@/form-components/FormSection';

import { KubernetesSecurityFormData } from './types';

interface PodSecurityConstraintsSectionProps {
  formData: KubernetesSecurityFormData;
  onChange: <K extends keyof KubernetesSecurityFormData>(
    key: K,
    value: KubernetesSecurityFormData[K]
  ) => void;
}

export function PodSecurityConstraintsSection({
  formData,
  onChange,
}: PodSecurityConstraintsSectionProps) {
  return (
    <FormSection title="Pod security constraints">
      <FormControl
        inputId="enable-pod-security-constraints"
        label="Enable pod security constraints"
        size="large"
      >
        <Switch
          id="enable-pod-security-constraints"
          data-cy="enable-pod-security-constraints-toggle"
          name="enablePodSecurityConstraints"
          className="space-right"
          checked={formData.enablePodSecurityConstraints || false}
          onChange={(value) => onChange('enablePodSecurityConstraints', value)}
        />
      </FormControl>
    </FormSection>
  );
}
